import React from 'react';
import PropTypes from 'prop-types';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import CircularProgress from '@material-ui/core/CircularProgress';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import IconButton from '@material-ui/core/IconButton';
import Snackbar from '@material-ui/core/Snackbar';
import SnackbarContent from '@material-ui/core/SnackbarContent';
import ErrorIcon from '@material-ui/icons/Error';
import CloseIcon from '@material-ui/icons/Close';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Switch from '@material-ui/core/Switch';
import red from '@material-ui/core/colors/red';
import { withStyles } from '@material-ui/core/styles';
import withMobileDialog from '@material-ui/core/withMobileDialog';
import request from 'superagent'
import * as Constants from '../constants'

const styles = theme => ({
  buttonProgress: {
    position: 'absolute',
    top: '50%',
    left: '50%',
    marginTop: -12,
    marginLeft: -12,
  },
  icon: {
    fontSize: 20,
    opacity: 0.9,
    marginRight: theme.spacing(1),
  },
  message: {
    display: 'flex',
    alignItems: 'center',
  },
});

class EditRemindersDialog extends React.Component {
  state = {
    loading: false,
  }

  handleChange = name => event => {
    this.setState({ [name]: event.target.checked });
  };

  editReminders = () => {
    this.setState({ loading: true });

    var reminders = (this.state.reminder_3_days !== undefined ? this.state.reminder_3_days : this.props.reminders.charAt(0) === "1") ? "1" : "0";
    reminders = reminders + ((this.state.reminder_1_day !== undefined ? this.state.reminder_1_day : this.props.reminders.charAt(1) === "1") ? "1" : "0");
    reminders = reminders + ((this.state.reminder_3_hours !== undefined ? this.state.reminder_3_hours : this.props.reminders.charAt(2) === "1") ? "1" : "0");
    reminders = reminders + ((this.state.reminder_1_hour !== undefined ? this.state.reminder_1_hour : this.props.reminders.charAt(3) === "1") ? "1" : "0");

    let currentComponent = this;
    request.post(Constants.BACKEND_URL)
      .set('Content-Type', 'application/x-www-form-urlencoded')
      .set('accept', 'json')
      .send({ command: "updatereminders", parent_id: this.props.parentId, reminders: reminders })
      .end((err, res) => {
        var result = res.text.trim();
        if (result === "1") {
          currentComponent.setState({ loading: false });
          currentComponent.props.onApply();
        } else {
          currentComponent.setState({ snackbar_open: true, loading: false });
        }
      });
  }

  handleSnackbarClose = () => {
    this.setState({ snackbar_open: false });
  }

  render() {
    const { classes, fullScreen } = this.props;
    return (
      <Dialog fullScreen={fullScreen} open={this.props.open} maxWidth="xs">
        <DialogTitle>{"Erinnerungen einrichten"}</DialogTitle>
        <DialogContent style={{ paddingLeft: 20, paddingRight: 20 }}>
          <DialogContentText>Sie können eine oder mehrere Erinnerungen einrichten. Sie werden dann über bevorstehende Ferienprogramme per E-Mail benachrichtigt.</DialogContentText>
          <FormControlLabel control={<Switch checked={this.state.reminder_3_days !== undefined ? this.state.reminder_3_days : this.props.reminders.charAt(0) === "1"} onChange={this.handleChange('reminder_3_days')} />} label="3 Tage vor der Veranstaltung" />
          <FormControlLabel control={<Switch checked={this.state.reminder_1_day !== undefined ? this.state.reminder_1_day : this.props.reminders.charAt(1) === "1"} onChange={this.handleChange('reminder_1_day')} />} label="1 Tag vor der Veranstaltung" />
          <FormControlLabel control={<Switch checked={this.state.reminder_3_hours !== undefined ? this.state.reminder_3_hours : this.props.reminders.charAt(2) === "1"} onChange={this.handleChange('reminder_3_hours')} />} label="3 Stunden vor der Veranstaltung" />
          <FormControlLabel control={<Switch checked={this.state.reminder_1_hour !== undefined ? this.state.reminder_1_hour : this.props.reminders.charAt(3) === "1"} onChange={this.handleChange('reminder_1_hour')} />} label="1 Stunde vor der Veranstaltung" />
        </DialogContent>
        <DialogActions>
          <Button onClick={this.props.onCancel} variant="contained" disabled={this.state.loading}>Abbrechen</Button>
          <Button onClick={this.editReminders} variant="contained" disabled={this.state.loading} color="primary" autoFocus>
            {"Änderungen übernehmen"}
            {this.state.loading && <CircularProgress size={24} className={classes.buttonProgress} />}
          </Button>
        </DialogActions>
        {/* Error-Snackbar */}
        <Snackbar className={classes.success} anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }} open={this.state.snackbar_open} autoHideDuration={3000} onClose={this.handleSnackbarClose}>
          <SnackbarContent
            message={
              <span className={classes.message}>
                <ErrorIcon className={classes.icon} />
                {"Es ist ein Fehler aufgetreten. Bitte versuchen Sie es erneut"}
              </span>
            }
            action={[
              <IconButton color="inherit" key="close" onClick={this.handleSnackbarClose}>
                <CloseIcon style={{ fontSize: 20 }} />
              </IconButton>,
            ]}
            style={{ backgroundColor: red[600] }} />
        </Snackbar>
      </Dialog>
    );
  }
}

EditRemindersDialog.propTypes = {
  classes: PropTypes.object.isRequired,
  fullScreen: PropTypes.bool.isRequired,
  theme: PropTypes.object.isRequired,
  open: PropTypes.bool.isRequired,
  parentId: PropTypes.string.isRequired,
  reminders: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
  onApply: PropTypes.func.isRequired,
};

export default withMobileDialog()(withStyles(styles, { withTheme: true })(EditRemindersDialog));
